<template>
  <div>
    <img src="@/assets/tarjeta_ofertas_seguro_movilidad_personal.jpg" style="width: 100%" />
    <p class="tituloTarjeta">SEGURO DE MOVILIDAD PERSONAL</p>
    <p>
      Ya seas peatón, pasajero de un medio de transporte o conductor de VMP,protégete con nuestro seguro de Movilidad
      Personal.
    </p>
    <ul style="list-style-type: disc">
      <li>Multimodal.</li>
      <li>Prima reducida.</li>
      <li>Multipersonas.</li>
    </ul>
    <p>¡Muévete con MMT Seguros!</p>
    <p class="container-flex">
      <a :href="'tel:' + telefonoOwner">
        <button class="pure-button botonLlamar" title="Pulsa el botón para llamar a tu oficina MMT">
          Llamar
        </button>
      </a>

      <a href="https://www.mmtseguros.com/seguros-movilidad-personal" target="_blank" class="link">
        <button class="pure-button botonLlamar">Infórmate</button>
      </a>
    </p>


    


  </div>
</template>

<script>
/* eslint-disable no-console */
export default {
  data() {
    return {
      telefonoOwner:
        this.$store.state.portfolio.cliente.telefonoOwnerPropioCliente,
    };
  },


};
</script>

<style lang="scss" scoped>
.container-flex {
  margin-top: 2.5rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  row-gap: 0.5rem;
  justify-content: space-around;
}

.botonLlamar {
  background-color: $colorMMT;
  color: white;
  font-weight: bold;
  width: 9rem;
  border: 0.15rem solid;
  border-radius: 0.5rem;
  text-align: center;
}

// .container-flex a:first-child {
//   margin-right: 15%;
// }
</style>
